/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 40,
  image: "default-changelog-v2.png",
  title: "New Platform Features & Enhancements",
  shortDescription: "We have released a new version of the Spheron platform with new Features & Enhancements.",
  description: "We have released a new version of the Spheron platform with new Features & Enhancements.",
  date: "July 31st, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron"]
};
export const content = `
## New Features & Enhancements
### IPFS Bandwidth & Requests Monitoring
We've enabled bandwidth and request tracking for our IPFS Gateway - ipfs.sphn.link. From now on, you'll have visibility on your organization's IPFS bandwidth usage and request numbers. Users on the default plan are allocated 10GB of Bandwidth, whereas Pro plan users get a generous 100GB. Additional bandwidth can be easily purchased for those with larger requirements. The best part - there are zero restrictions on the number of requests!

### Invoice Creation System

A new, user-friendly invoice creation system is now live. This feature offers detailed information regarding plan upgrades and bonus purchases and allows you to download invoices in PDF for your accounting purpose. Billing details for your company can now be conveniently configured within the Invoice Setting section on the Billing page.

### Deployment Environment Flexibility

We're excited to announce enhancements to our deployment environment. Starter package users can now deactivate a predefined environment and establish their own custom ones, providing greater flexibility to align with specific project needs. Note that a maximum of two active environments per project are allowed with the Starter plan. For additional customization and flexibility, users can switch between active environments as per changing project demands, or opt for a higher-tier subscription for more complex adaptability.

`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
